import {createFeatureSelector, createSelector} from "@ngrx/store";
import * as fromMap from "@core/ngrx/reducers/aux/map.reducer";

export const selectMapState = createFeatureSelector<fromMap.State>('map');
export const selectMapActionsPolicy = createSelector(selectMapState, (state: fromMap.State) => {
  return state.mapActionsPolicy
});
export const selectUserMap = createSelector(selectMapState, (state: fromMap.State) => state.userMap);
export const selectOriginalMarkersGeoJson = createSelector(selectMapState, (state: fromMap.State) => state.originalMarkersGeoJson);
export const selectIsClusterMode = createSelector(selectMapState, (state: fromMap.State) => state.isClusterMode);
